module.exports = __webpack_public_path__ + "static/media/location.ed8691f8.svg";